import React, { useState } from "react";
import { TextInput, Button, Label } from "flowbite-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import NavbarVoltar from "../NavbarVoltar";
import { registerUser } from "../../actions/user";

const CadastraUsuario = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, error: registerError } = useSelector((state) => state.user);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateUsername = (username) => {
    const regex = /^[a-z0-9-]+$/i;
    return regex.test(username);
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$/;
    return regex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!validateUsername(formData.username)) {
      setError(
        "Nome de usuário inválido. Use apenas letras, números, '.' ou '_'"
      );
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    if (!validatePassword(formData.password)) {
      setError(
        "A senha deve ter pelo menos 6 caracteres, incluindo letras e números."
      );
      return;
    }

    try {
      await dispatch(registerUser(formData, navigate));
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#fff1be] via-[#ee87cb] to-[#b060ff]">
      {/* Navbar */}
      <NavbarVoltar />

      {/* Card Container */}
      <div className="flex items-center justify-center min-h-[80vh] mt-8">
        <div className="bg-white shadow-lg rounded-3xl mx-2 px-8 py-10 max-w-md w-full">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-6">
            Crie sua Conta
          </h1>
          <p className="text-center text-gray-600 mb-6">
            Preencha os dados abaixo para começar a usar a plataforma Vintree.
          </p>

          {/* Formulário de Cadastro */}
          <form className="space-y-6" onSubmit={handleSubmit}>
            {/* Username */}
            <div>
              <Label htmlFor="username" className="block mb-2">
                Nome de Usuário (será o @ da sua loja)
              </Label>
              <TextInput
                id="username"
                name="username"
                type="text"
                placeholder="ex: loja_da_lari"
                value={formData.username}
                onChange={handleChange}
                required
              />
              <p className="text-sm text-gray-500 mt-1">
                Esse nome será usado na URL do seu catálogo:{" "}
                <span className="font-mono text-gray-700 font-semibold">
                  vintree.com.br/{formData.username || "seu-username"}
                </span>
              </p>
            </div>

            {/* Email */}
            <div>
              <Label htmlFor="email" className="block mb-2">
                Email
              </Label>
              <TextInput
                id="email"
                name="email"
                type="email"
                placeholder="seu@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* Senha */}
            <div>
              <Label htmlFor="password" className="block mb-2">
                Senha
              </Label>
              <TextInput
                id="password"
                name="password"
                type="password"
                placeholder="Escolha uma senha segura"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            {/* Confirmar Senha */}
            <div>
              <Label htmlFor="confirmPassword" className="block mb-2">
                Confirmar Senha
              </Label>
              <TextInput
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                placeholder="Digite a senha novamente"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
            </div>

            {/* Exibir Erro */}
            {error && <p className="text-red-500 text-sm">{error}</p>}
            {registerError && (
              <p className="text-red-500 text-sm">{registerError}</p>
            )}

            {/* Botão de Cadastro */}
            <div>
              <Button
                type="submit"
                size="lg"
                className="w-full bg-black text-white hover:bg-gray-800 rounded-lg"
                disabled={loading}
              >
                {loading ? "Cadastrando..." : "Cadastrar"}
              </Button>
            </div>
          </form>

          {/* Termos */}
          <div className="mt-6 text-center text-sm text-gray-600">
            <p>
              Ao se cadastrar, você concorda com nossos{" "}
              <Link
                to="/termos"
                className="font-medium text-indigo-600 hover:underline"
              >
                Termos de Uso
              </Link>{" "}
              e{" "}
              <Link
                to="/politicas"
                className="font-medium text-indigo-600 hover:underline"
              >
                Políticas de Privacidade
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CadastraUsuario;
